import client from './client';

export async function uploadDocument(candidateId, formData) {
  const { data } = await client.post(`/candidates/${candidateId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data.data;
}

export async function downloadDocument(id) {
  const response = await client.get(`/documents/${id}/download`, { responseType: 'blob' });
  return response;
}

export async function verifyDocument(id) {
  const { data } = await client.patch(`/documents/${id}/verify`);
  return data.data;
}

export async function unverifyDocument(id) {
  const { data } = await client.patch(`/documents/${id}/unverify`);
  return data.data;
}

export async function deleteDocument(id) {
  await client.delete(`/documents/${id}`);
}
